import React from "react";
import {
  SettingsIcon,
  LogoutIcon,
  CogsIcon,
  EditProjectIcon,
  HomeIcon,
  DropDownMenuBare,
  Avatar,
  DuplicateIcon,
} from "djinn-components";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { supabase } from "../../utils/initSupabase";
import { imagePath } from "../../utils/urls";
import { useSiteState } from "../../utils/useSiteState";
import { Link, useNavigate } from "react-router-dom";
import usePathname from "../../utils/usePathname";

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const pathname = usePathname();
  const { site } = useSiteState();

  const MenuItem = ({
    Icon = EditProjectIcon,
    title,
    to = `/${site.id}/edit`,
  }: any) => {
    
    const isActive =
      (to !== `/${site.id}` && pathname?.includes(to)) ||
      (to === `/${site.id}` && to === pathname);

    return (
      <Link to={to}>
        <div
          data-tooltip-id="menu-item"
          data-tooltip-content={title}
          className={`flex justify-center items-center group mt-2 font-medium text-sm text hover:text-white transition ease-in-out duration-150 p-3 ${
            isActive ? "text-white" : "text-gray-450"
          }`}
        >
          <Icon className={`h-6 w-6 ${isActive && "text-green-600"}`} />
        </div>
      </Link>
    );
  };

  const logout = async () => {
    await supabase.auth.signOut();
    navigate("/");
  };

  return (
    <div className="flex flex-col w-20 flex-shrink-0 bg-gray-900 shadow rounded-r-xl h-screen">
      <div className="flex flex-col h-0 flex-1">
        <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto p-2">
          <div className="flex items-center justify-center flex-shrink-0 p-2 relative h-10 w-10 mx-auto">
            <img
              src="/icon.png"
              alt="Appsicle logo"
              className="object-cover object-center"
            />
          </div>

          <nav className="mt-5 flex items-center flex-col justify-center">
            <MenuItem title="Dashboard" to={`/${site.id}`} Icon={HomeIcon} />
            <MenuItem title="Details" to={`/${site.id}/edit`} />
            <MenuItem
              title="Pages"
              to={`/${site.id}/pages`}
              Icon={DuplicateIcon}
            />
            <MenuItem
              title="Settings"
              to={`/${site.id}/settings`}
              Icon={SettingsIcon}
            />

            <ReactTooltip place="right" />
          </nav>
        </div>
        <div className="flex items-center justify-center mb-5 flex-col">
          {/* @ts-ignore */}
          <DropDownMenuBare
            button={<Avatar img={imagePath(site.favicon)} text={site.title} />}
            className="absolute -left-2.5 bottom-14 bg-gray-900 mt-8 rounded shadow-xl w-80 text-white z-20"
          >
            <Link to="/account">
              <div className="p-4 text-sm flex items-center hover:bg-gray-950">
                <CogsIcon className="block w-5 h-5 mr-3" size={18} />
                <span>Account Settings</span>
              </div>
            </Link>
            <Link to="/">
              <div className="p-4 text-sm flex items-center hover:bg-gray-950">
                <CogsIcon className="block w-5 h-5 mr-3" size={18} />
                <span>Switch Project</span>
              </div>
            </Link>
            <button
              className="w-full p-4 text-sm flex items-center hover:bg-gray-950 rounded-b"
              onClick={logout}
            >
              <LogoutIcon className="block w-5 h-5 mr-3" size={18} />
              <span>Logout</span>
            </button>
            <div
              className="absolute left-4 rounded-sm"
              style={{
                bottom: "-1rem",
                width: 0,
                height: 0,
                borderLeft: "1rem solid transparent",
                borderRight: "1rem solid transparent",
                borderTop: "1rem solid #110f15",
              }}
            ></div>
          </DropDownMenuBare>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
